var EventStream = require('./lib/event_stream');
module.exports = new EventStream();



//////////////////
// WEBPACK FOOTER
// ./~/eventing-bus/index.js
// module id = 24
// module chunks = 0